import { useRef, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { AdminPhotoCard } from "@/components/admin/AdminPhotoCard";

const moveItem = (list, from, to) => {
    const next = [...list];
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item);
    return next;
};

export const AdminPhotoGrid = ({ photos, setPhotos }) => {
    const [dragIndex, setDragIndex] = useState(null);
    const saveTimer = useRef(null);

    const persistOrder = (list) => {
        clearTimeout(saveTimer.current);
        saveTimer.current = setTimeout(async () => {
            try {
                await api.put("/admin/gallery/order", { ids: list.map((p) => p.id) });
                toast.success("Ordine salvato.");
            } catch (err) {
                toast.error(apiError(err, "Ordine non salvato."));
            }
        }, 600);
    };

    const move = (from, to) => {
        if (to < 0 || to >= photos.length || from === to) return;
        const next = moveItem(photos, from, to);
        setPhotos(next);
        persistOrder(next);
    };

    const dragProps = (index) => ({
        draggable: true,
        onDragStart: (e) => { setDragIndex(index); e.dataTransfer.effectAllowed = "move"; },
        onDragOver: (e) => {
            e.preventDefault();
            if (dragIndex === null || dragIndex === index) return;
            setPhotos((prev) => moveItem(prev, dragIndex, index));
            setDragIndex(index);
        },
        onDragEnd: () => { setDragIndex(null); persistOrder(photos); },
        onDrop: (e) => e.preventDefault(),
    });

    if (!photos.length) {
        return (
            <p data-testid="admin-gallery-empty" className="border border-white/10 p-10 text-center text-sm text-tl-mutedLight">
                Nessuna foto in galleria. Carica le prime immagini qui sopra.
            </p>
        );
    }

    return (
        <>
            <p className="mb-4 font-mono-tl text-[10px] uppercase tracking-[0.2em] text-white/40">
                Trascina le foto per cambiare l'ordine · la prima appare in grande
            </p>
            <div data-testid="admin-gallery-grid" className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
                {photos.map((p, i) => (
                    <AdminPhotoCard
                        key={p.id}
                        photo={p}
                        index={i}
                        total={photos.length}
                        dragging={dragIndex === i}
                        dragProps={dragProps(i)}
                        onMove={move}
                        onDeleted={(id) => setPhotos((prev) => prev.filter((x) => x.id !== id))}
                        onUpdated={(upd) => setPhotos((prev) => prev.map((x) => (x.id === upd.id ? upd : x)))}
                    />
                ))}
            </div>
        </>
    );
};
